import React, { useContext } from "react";
import HelpPanel from "@amzn/awsui-components-react/polaris/help-panel";
import { Link } from "@amzn/awsui-components-react";
import { useLocation } from "react-router-dom";
import CONSTANTS, { IS_SUPPORT_TICKET_ENABLED } from "src/utils/constants";
import { GlobalAppContext } from "../App";

export default function ContactSupport() {
    const { pathname } = useLocation();
    const { globalState } = useContext(GlobalAppContext);
    const { selectedTab } = globalState;

    const createSupportTicket = (event: any) => {
        event.preventDefault();
        if (pathname.startsWith(CONSTANTS.PAGE_NAV.REPORT_DASHBOARD.URL) 
            || (pathname.startsWith(CONSTANTS.PAGE_NAV.MONTH_END_CLOSE.URL) 
                && (selectedTab == CONSTANTS.MEC_TABS.PREVALIDATION || selectedTab == CONSTANTS.MEC_TABS.JE_STATUS_DASHBOARD))) {
            window.open(CONSTANTS.ENVIRONMENT_VARIABLES.REPORTING_SUPPORT_TICKET_TEMPLATE);
        } else {
            window.open(CONSTANTS.ENVIRONMENT_VARIABLES.SUPPORT_TICKET_TEMPLATE);
        }
    }
    
    return (
        <HelpPanel header={"Contact Support"}>
            <div>
                {IS_SUPPORT_TICKET_ENABLED
                ?
                    <Link href="#" variant="primary" onFollow={(event: any) => createSupportTicket(event)}>Create support ticket</Link>
                :
                    <span>Support is only available in the production and pre-prod environments. Contact the ATP PM to report issues in other environments.</span>
                }
            </div>
        </HelpPanel>
    );
};